<template>
  <section class="related-articles">
    <div class="container">
      <h2 class="title">There’s plenty more to explore</h2>
      <p class="subtitle">
        A world of content to explore right at your fingertips.
      </p>
    </div>
    <div class="container cards-container">
      <div class="cards-wrapper">
        <div
          ref="carousel"
          class="cards"
          :style="`left:${dataItems.left}`"
        >
          <ArticleCard
            v-for="article in articles"
            ref="cardRef"
            :key="article.id"
            :article="article"
            class="article-card"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="mobile-content">
        <div class="nav-dots">
          <div
            v-for="(article, index) in articles"
            :key="index"
            class="nav-dot"
            :class="dataItems.index === index && 'active'"
          ></div>
        </div>
      </div>

      <div class="explore-more">
        <nuxt-link to="/journal">
          <span
            class="proxify-btn proxify-btn-white-outline"
            @click="trackEvent"
          >
            Explore more
          </span>
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script>
import ArticleCard from '~/components/Common/ArticleCard/ArticleCard.vue';
import carousel from '~/mixins/carousel';

export default {
  components: { ArticleCard },
  mixins: [carousel],
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        cta_name: 'Explore more',
        section: 'Related Articles',
        page_name: 'Lead gen page v1',
      });
    },
    setActiveItem(direction) {
      try {
        const cardReference = this.$refs.cardRef[0].$el;
        const currentIndex = this.dataItems.index;
        const newIndex =
          direction === 'next' ? currentIndex + 1 : currentIndex - 1;
        const lastIndex = this.articles.length - 1;
        const increment = direction === 'next' ? -1 : 1;

        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }

        this.dataItems = {
          left: `${
            this.dataItems.value + increment * (cardReference.clientWidth + 16)
          }px`,
          value: this.dataItems.value + increment * cardReference.clientWidth,
          index: newIndex,
          transition: '0.6s',
        };
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './RelatedArticlesSection.scss';
</style>
